import { GlLink, GlPopover, GlSprintf, GlTooltipDirective, GlBadge } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import { SCHEDULE_ORIGIN, API_ORIGIN, TRIGGER_ORIGIN, AGENT_SESSION_ORIGIN } from '../constants';
export default {
    name: 'PipelineLabels',
    components: {
        GlBadge,
        GlLink,
        GlPopover,
        GlSprintf
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        pipelineSchedulesPath: {
            default: ''
        }
    },
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    computed: {
        isScheduled () {
            return this.pipeline.source === SCHEDULE_ORIGIN;
        },
        isTriggered () {
            return this.pipeline.source === TRIGGER_ORIGIN;
        },
        isForked () {
            // REST returns `forked`, GraphQL returns `isForked`.
            return this.pipeline?.project?.forked || this.pipeline?.project?.isForked;
        },
        showMergedResultsBadge () {
            // A merge train pipeline is technically also a merged results pipeline,
            // but we want the badges to be mutually exclusive.
            const isMergedResult = this.pipeline?.flags?.merged_result_pipeline || this.pipeline?.mergeRequestEventType === 'MERGED_RESULT';
            return isMergedResult && !this.isMergeTrainPipeline;
        },
        showBranchBadge () {
            return this.pipeline?.flags?.type === 'branch' || this.pipeline?.type === 'branch';
        },
        showTagBadge () {
            return this.pipeline?.flags?.type === 'tag' || this.pipeline?.type === 'tag';
        },
        autoDevopsTagId () {
            return `pipeline-url-autodevops-${this.pipeline.id}`;
        },
        autoDevopsHelpPath () {
            return helpPagePath('topics/autodevops/_index.md');
        },
        isApi () {
            return this.pipeline.source === API_ORIGIN;
        },
        hasLatestFlag () {
            return this.pipeline?.flags?.latest || this.pipeline?.latest;
        },
        isMergeTrainPipeline () {
            return this.pipeline?.flags?.merge_train_pipeline || this.pipeline?.mergeRequestEventType === 'MERGE_TRAIN';
        },
        isDetached () {
            return this.pipeline?.flags?.detached_merge_request_pipeline || this.pipeline?.mergeRequestEventType === 'DETACHED';
        },
        hasYamlErrors () {
            return this.pipeline?.flags?.yaml_errors || this.pipeline?.yamlErrors;
        },
        hasFailureReason () {
            return this.pipeline?.flags?.failure_reason || Boolean(this.pipeline?.failureReason);
        },
        failureReason () {
            return this.pipeline?.failure_reason || this.pipeline?.failureReason;
        },
        autoDevopsSource () {
            return this.pipeline?.flags?.auto_devops || this.pipeline?.configSource === 'AUTO_DEVOPS';
        },
        stuck () {
            return this.pipeline?.flags?.stuck || this.pipeline?.stuck;
        },
        isAgentSession () {
            return this.pipeline?.source === AGENT_SESSION_ORIGIN;
        }
    },
    buttonClass: '!gl-cursor-default gl-rounded-pill gl-border-none gl-bg-transparent gl-p-0'
};
